import React from 'react';
import { useRouteMatch, useParams, Route } from 'react-router-dom';

import SatisfactionHealth from '../pages/SatisfactionHealth/SatisfactionHealth';
import Nps from '../pages/Nps/Nps';
import Tickets from '../pages/Tickets/Tickets';
import Csat from '../pages/Csat/Csat';
import Qbr from '../pages/Qbr/Qbr';
import Sentiment from '../pages/Sentiment/Sentiment';

import classes from './SatisfactionRouts.module.scss';

const SatisfactionRouts = () => {
  let { url } = useRouteMatch();

  const params = useParams();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <div className={classes.satisfaction}>
      <Route path={`${newUrl}/satisfaction/health-score`}>
        <SatisfactionHealth customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/satisfaction/nps`}>
        <Nps customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/satisfaction/open-tickets`}>
        <Tickets customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/satisfaction/csat`}>
        <Csat customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/satisfaction/qbr`}>
        <Qbr customerId={params.id} />
      </Route>
      <Route path={`${newUrl}/satisfaction/sentiment`}>
        <Sentiment customerId={params.id} />
      </Route>
    </div>
  );
};

export default SatisfactionRouts;
